// start:ng42.barrel
export * from './patient.facade';
export * from './patient.model';
// end:ng42.barrel

